export default __webpack_public_path__ + "static/media/contact-me.413d5087.jpg";